import { t } from 'ember-intl';
import type PlanModel from 'tio-data/models/plan';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import type { TOC } from '@ember/component/template-only';

interface PlanContributionCardSignature {
  Args: {
    plan: PlanModel;
  };
  Element: HTMLDivElement;
}

const PlanContributionCardComponent: TOC<PlanContributionCardSignature> = <template>
  <div
    class="tio-fg-secondary border tio-border-default rounded p-2 pr-4 m-2 hover:shadow-lg w-3/4 grid grid-cols-2"
    ...attributes
  >
    <div class="col-1">
      <div>
        <span>{{t "plans.plan_key"}}</span>
        <span class="font-semibold">{{@plan.companyKey}}</span>
      </div>
      <div>
        <span>{{t "plans.plan_start_date"}}</span>
        <span class="font-semibold">{{safeFormatDate @plan.createdAt}}</span>
      </div>
      <div>
        <span>{{t "plans.plan_name"}}</span>
        <span class="font-semibold">{{@plan.name}}</span>
      </div>
    </div>
    <div class="col-1">
      <div>
        <span>{{t "plans.employees_enrolled"}}</span>
        {{! @glint-expect-error seems like a bug}}
        <span>{{@plan.employees_enrolled}}</span>
      </div>
      <div>
        <span>{{t "plans.employee_eligibility_waiting_period"}}</span>
        {{! @glint-expect-error seems like a bug}}
        <span>{{@plan.employment_eligibility}}</span>
      </div>
    </div>
  </div>
</template>;

export default PlanContributionCardComponent;
